<div *ngFor="let shimmer of shimmer_list; let i = index" class="container-fluid p-0 mt-5">


   <!-- for: special section -->
   <div class="ms-4 d-flex flex-column gap-3" *ngIf="section_type === 'special'">
     <p-skeleton width="16rem" height="2rem"></p-skeleton>
     <p-skeleton width="8rem" height="2rem"></p-skeleton>
   </div>

   <!-- for: normal sections -->
   <div class="ms-4 d-flex justify-content-center" *ngIf="section_type === 'normal'">
      <p-skeleton width="16rem" height="2rem"></p-skeleton>
   </div>

   <app-skelton></app-skelton>

</div>
